import { toFixed } from 'accounting-js';

interface CouponTicketTypeDiscountParams {
  amount: number;
  coupon: { amountOff?: number; percentOff?: number; ticketTypes?: string[] } | null | undefined;
  ticketTypeId: string;
  quantity: number;
}

export const getCouponTicketTypeDiscount = ({
  amount,
  coupon,
  ticketTypeId,
  quantity,
}: CouponTicketTypeDiscountParams): number => {
  const chargeAmount = Number(amount);

  if (!coupon) {
    return 0;
  }

  const appliesToThisTicket = (coupon.ticketTypes ?? []).some(
    couponTicketTypeId => couponTicketTypeId === ticketTypeId,
  );

  if (!appliesToThisTicket) {
    return 0;
  }

  // Calculate discount amount
  let discount: number | null = null;

  if (coupon.amountOff) {
    discount = coupon.amountOff * quantity;
  }

  if (coupon.percentOff) {
    discount = chargeAmount - chargeAmount * (1 - coupon.percentOff / 100);
  }

  // Cap discount to never exceed the amount (prevent negative prices)
  const cappedDiscount = Math.min(discount || 0, chargeAmount);

  return Number(toFixed(cappedDiscount));
};
